// extracted by mini-css-extract-plugin
module.exports = {"form-append":"_3KcMG_OZ"};